import React from 'react';

import { LegacyIconProps } from './iconUtilities';

export function ZoomToRegionIcon({ 
    width = 24, 
    height = 24, 
    color = '#666666'
}: LegacyIconProps) {
    return (
        <svg id='mapZoomToRegionIcon' className='mapIcon' viewBox='-1 -1 25 25' width={width} height={height} stroke={color}>
            <path d='M24.9131707,24.9176471 L18.2696585,18.2729412' strokeWidth='2' fill='none'></path>
            <ellipse id='Oval' cx='10.6770732' cy='10.6789916' rx='10.6770732' ry='10.6789916' strokeWidth='2' fill='none'></ellipse>
            <path d='M10.6770732,7.11932773 L10.6770732,14.2386555' strokeWidth='2' fill='none'></path>
            <path d='M14.2360976,10.6789916 L7.11804878,10.6789916' strokeWidth='2' fill='none'></path>
        </svg>
    );
}
